import type { GetSubscriptionsMeResponse } from '@heybesafe/shared';
import { request } from './client';
import type { ApiResponse } from './client';

/**
 * Fetches the user's entitlement snapshot + subscription list. Used by
 * SafeContext on unlock and on any 4xx EntitlementError refresh path.
 *
 * Wraps the existing `request<T>` helper so we inherit token refresh,
 * Authorization header, X-Client-Platform header, and the
 * ApiResponse<T> discriminated-union return convention.
 */
export function fetchEntitlement(): Promise<ApiResponse<GetSubscriptionsMeResponse>> {
  return request<GetSubscriptionsMeResponse>('/subscriptions/me', { method: 'GET' });
}
